import { styled, theme } from 'ui/theme';

export const TextBlockStyle = {
  Component: styled('div')`
    align-items: center;
    display: flex;
  `,

  IconWrapper: styled('div')`
    margin-right: ${theme.sizes[2]};
    padding-top: ${theme.sizes[1]};

    &[data-icon-color='alert'] {
      color: ${theme.colors.status.alert.standard};
    }

    &[data-icon-color='error'] {
      color: ${theme.colors.status.error.standard};
    }

    &[data-icon-color='success'] {
      color: ${theme.colors.status.success.standard};
    }
  `,

  Info: styled('div')`
    color: ${theme.colors.build.mediumLight1};
  `,
};
